export const starColorMap = {
    3: 'rgba(10,5,5,0.98)',
    4: '#bb58f1',
    5: '#ff0026',
};

export const themeConfig = {
    defaultTargetImage: '/images/bg.jpg',
    historyTitle: '祈愿历史',
    historyEmptyCopy: '你的抽卡故事还没开始。',
    retargetTitle: '当前定轨',
    retargetDescription: '新的目标已经出现，是否切换本轮心愿？',
    jumpLink: 'https://divination.sunls.de/',
    luckMeter: {
        calm: '今日手气：平稳积累中',
        focused: '今日手气：目标已锁定',
        tense: '今日手气：临近保底，悬念拉满',
        jackpot: '今日手气：金光刚刚降临',
        'target-hit': '今日手气：命定目标已到手',
    },
    pityCopy: {
        normal(progressLeft) {
            if (progressLeft <= 1) return '再来 1 次，必出五星。';
            return `再来 ${progressLeft} 次，金光就会降临。`;
        },
        targeted(progressLeft) {
            if (progressLeft <= 1) return '再来 1 次，本轮定轨必定命中。';
            return `离定轨命中还差 ${progressLeft} 次。`;
        },
        idle: '本轮欧气积累中。',
        hitTarget: '命中定轨，今天就按这个来。',
        freshFiveStar: '金光闪过，今天的好运被你抽到了。',
    },
    startupRecommendation: {
        title: '今日灵签',
        spinningCopy: '签筒轻响，今日缘分正在慢慢摇出。',
        resultCopy: '签文已落定，今天不如先应这一签。',
        closeLabel: '收下这一签',
    },
};

export function getStarColor(star) {
    return starColorMap[star] ?? starColorMap[3];
}
